export enum EPhoneVerificationStatus {
  /** Введен неправильный код **/
  Error = 'error',
  /** В процессе проверки **/
  InProgress = 'inProgress',
  /** Проверка успешно завершена **/
  Ok = 'ok',
  /** Проверка пропущенна **/
  Skipped = 'skipped',
  /** Проблема с отправкой **/
  SendError = 'sendError',
}
